module.exports = __webpack_public_path__ + "fonts/b7066775-c685-4630-b98c-5da67d4981e9.a8b161e.eot";